/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The helper to correct provided date range by minimum month count
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.2.0
 * @since 1.2.0
 */

import moment, { Moment } from 'moment';

export interface ICorrectRangeParams {
    minDate?: Moment;
    minMonthCount: number;
    rangeEnd: Moment;
    rangeStart: Moment;
}

export const correctRangeByMinMonthCount = (params: ICorrectRangeParams) => {
    const minDate = params.minDate ?? moment().subtract(3, 'year');
    let { rangeEnd, rangeStart } = params;

    const diffCurrent = moment(rangeEnd).diff(rangeStart, 'months');
    const diffMin = params.minMonthCount - 1;
    const diff = diffCurrent > diffMin ? diffCurrent : diffMin;

    if (rangeEnd.clone().subtract(diff, 'month') < minDate) {
        rangeStart = minDate;
        rangeEnd = rangeStart.clone().add(diff, 'month');
    } else {
        rangeStart = rangeEnd.clone().subtract(diff, 'month');
    }
    return [rangeStart, rangeEnd];
};

